'use strict';

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*!
 * angular-translate - v2.7.2 - 2015-06-01
 * http://github.com/angular-translate/angular-translate
 * Copyright (c) 2015 ; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return factory();
    });
  } else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
})(undefined, function () {

  angular.module('pascalprecht.translate')

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateMissingTranslationHandlerLog
   * @requires $log
   *
   * @description
   * Uses angular's `$log` service to give a warning when trying to translate a
   * translation id which doesn't exist.
   *
   * @returns {function} Handler function
   */
  .factory('$translateMissingTranslationHandlerLog', $translateMissingTranslationHandlerLog);

  function $translateMissingTranslationHandlerLog($log) {

    'use strict';

    return function (translationId) {
      $log.warn('Translation for ' + translationId + ' doesn\'t exist');
    };
  }
  $translateMissingTranslationHandlerLog.$inject = ['$log'];

  $translateMissingTranslationHandlerLog.displayName = '$translateMissingTranslationHandlerLog';
  return 'pascalprecht.translate';
});


// WEBPACK FOOTER //
// ./js/vendor/angular-translate-handler-log/angular-translate-handler-log.js